var map = {
	"./bangla_consent.pdf": 21421,
	"./english_consent.pdf": 93999,
	"./hindi_consent.pdf": 18812,
	"./malayalam_consent.pdf": 46842,
	"./urdu_consent.pdf": 45319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88412;